import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "company-section" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "social-links" }
const _hoisted_4 = {
  href: "https://www.facebook.com/computerinforbusiness",
  target: "_blank"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  href: "https://www.linkedin.com/company/computerinfor",
  target: "_blank"
}
const _hoisted_8 = ["src"]
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  href: "https://gitlab.com/Groamer",
  target: "_blank"
}
const _hoisted_11 = ["src"]
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "copyright-section" }
const _hoisted_14 = { class: "container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_contact_details_table = _resolveComponent("contact-details-table")!
  const _component_triple_block = _resolveComponent("triple-block")!
  const _component_opening_hours_table = _resolveComponent("opening-hours-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        ($props.displayContactDetails)
          ? (_openBlock(), _createBlock(_component_triple_block, { key: 0 }, {
              default: _withCtx(() => [
                _cache[0] || (_cache[0] = _createElementVNode("h2", null, "Contactgegevens", -1)),
                _createVNode(_component_contact_details_table)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        ($props.displayOpeningHours)
          ? (_openBlock(), _createBlock(_component_triple_block, { key: 1 }, {
              default: _withCtx(() => [
                _cache[1] || (_cache[1] = _createElementVNode("h2", null, "Contacturen", -1)),
                _createVNode(_component_opening_hours_table)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_triple_block, null, {
          default: _withCtx(() => [
            _cache[4] || (_cache[4] = _createElementVNode("h2", null, "Sociale media", -1)),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("a", _hoisted_4, [
                _createElementVNode("img", { src: $data.facebookLogo }, null, 8, _hoisted_5),
                _createElementVNode("img", { src: $data.facebookLogoActive }, null, 8, _hoisted_6)
              ]),
              _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
              _createElementVNode("a", _hoisted_7, [
                _createElementVNode("img", { src: $data.linkedinLogo }, null, 8, _hoisted_8),
                _createElementVNode("img", { src: $data.linkedinLogoActive }, null, 8, _hoisted_9)
              ]),
              _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
              _createElementVNode("a", _hoisted_10, [
                _createElementVNode("img", { src: $data.gitlabLogo }, null, 8, _hoisted_11),
                _createElementVNode("img", { src: $data.gitlabLogoActive }, null, 8, _hoisted_12)
              ])
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("section", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _cache[5] || (_cache[5] = _createElementVNode("a", { href: "/algemene_voorwaarden" }, "Algemene voorwaarden", -1)),
        _cache[6] || (_cache[6] = _createTextVNode(" | ", -1)),
        _cache[7] || (_cache[7] = _createElementVNode("a", { href: "/sitemap" }, "Sitemap", -1)),
        _createTextVNode(" | © 2014 - " + _toDisplayString($data.currentYear) + " ComputerInfor | Ontwerp en ontwikkeling door ", 1),
        _cache[8] || (_cache[8] = _createElementVNode("a", {
          href: "https://www.linkedin.com/in/tom-remeeus-87508a96/",
          target: "_blank"
        }, "Tom Remeeus", -1))
      ])
    ])
  ], 64))
}